import { Box, Button, Container, Divider, Grid, IconButton, Paper } from "@mui/material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Link, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import globalContext from '../context/context'
import axios from "axios";
import parse from 'html-react-parser';
import { CssTextField } from "../utils/CssTextField";
import { useTranslation } from "react-i18next";
import { isInCart } from "../utils/cart";

function LoungePopup() {

    const { t } = useTranslation();
    const { contextData: { responseId, lounge, currency, cart, formValues }, setLounge, addToCart, setSnack } = useContext(globalContext);
    const navigate = useNavigate();

    const [details, setDetails] = useState(false);
    const [additionalData, setAdditionalData] = useState({
        usageStartDate: '',
        usageEndDate: ''
    });



    useEffect(() => {
        if (!parseInt(responseId, 10)) {
            navigate('/');
        }
    }, [])

    const convertDate = (dateO) => {
        let finalDate = new Date();
        if (dateO?.toString() == dateO) {
            finalDate = new Date(dateO);
        } else {
            finalDate = new Date(dateO?.toISOString())
        }

        finalDate = new Date(finalDate?.getTime() + (new Date().getTimezoneOffset() * -1 * 60000));
        return finalDate?.toISOString()?.substring(0, 19)
    }

    useEffect(() => {
        if (formValues) {
            setAdditionalData({
                usageStartDate: convertDate(new Date(new Date(formValues?.departureSideStartDate).getTime() - 4 * 60 * 60 * 1000)),
                usageEndDate: convertDate(new Date(new Date(formValues?.departureSideStartDate).getTime() - 1 * 60 * 60 * 1000)),
            })
        }
    }, [formValues])

    useEffect(() => {

        const getLounges = setTimeout(() => {
            if (!!parseInt(responseId, 10)) {
                axios.get(`/api/custom/lounges?searchId=${parseInt(responseId, 10)}&currency=${currency}`).then(r => {
                    setLounge(r?.data);
                }).catch(e => {
                    setLounge(null);
                })
            }
        }, 400);


        return () => {
            clearTimeout(getLounges);
        }

    }, [responseId])


    const setAdditionalDataChange = (e) => {
        setAdditionalData({ ...additionalData, [e.target.name]: e.target.value });
    }

    const handleAddToCart = (p) => {
        if (additionalData?.usageEndDate && additionalData?.usageStartDate) {
            const usageStartDate = new Date(additionalData.usageStartDate);
            const usageEndDate = new Date(additionalData.usageEndDate);
            addToCart({
                ...p,
                usageStartDate,
                usageEndDate
            }, 'lounges');
        } else {
            setSnack({
                message: 'Usage End Date and Usage Start Date are required.',
                severity: 'error',
                open: true
            })
        }
    }


    return (
        <>
            <Box className="orderElement" sx={{ bgcolor: 'rgba(0,0,0, .2)' }}>
                <Container sx={{ justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex' }} >
                    <Paper className="orderElementPaper" sx={{ width: { xs: '95%', md: '60%' }, p: 3, bgcolor: '#fff' }}>
                        <Grid sx={{ justifyContent: 'space-between', alignItems: 'center' }} container>
                            <Grid item>
                                <Box sx={{ display: 'inline-block', color: '#d93e45', fontSize: '16px', fontWeight: 500 }}>
                                    <Box sx={{
                                        width: '40px',
                                        height: '40px',
                                        display: 'inline-block',
                                        mr: 2,
                                        verticalAlign: 'middle',
                                        backgroundImage: `url('/images/lounge.png')`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                    }}></Box>
                                    {t("PopupPages.lounge")}
                                </Box>
                            </Grid>
                            <Grid item>
                            </Grid>
                        </Grid>
                        {lounge && <>
                            {lounge?.length > 0 ?
                                <>
                                    <Grid sx={{ py: 2 }} >
                                        <Divider />
                                    </Grid>
                                    <Grid sx={{ py: 2 }} >

                                        <CssTextField size="small"
                                            value={additionalData?.usageStartDate}
                                            type="datetime-local"
                                            name="usageStartDate"
                                            // disabled={true}
                                            onChange={setAdditionalDataChange}
                                            sx={{ mt: 1 }} fullWidth variant="standard" label={t("PopupPages.usageStartDate")} />
                                        <CssTextField size="small"
                                            value={additionalData?.usageEndDate}
                                            type="datetime-local"
                                            name="usageEndDate"
                                            // disabled={true}
                                            onChange={setAdditionalDataChange}
                                            sx={{ mt: 1 }} fullWidth variant="standard" label={t("PopupPages.usageEndDate")} />

                                    </Grid>
                                </>
                                :
                                <>
                                    <Grid sx={{ py: 2 }} >
                                        <Divider />
                                    </Grid>
                                    <Grid sx={{ py: 2 }} >
                                        Coming soon…
                                    </Grid>
                                </>
                            }
                        </>}
                        {lounge && lounge?.map((p, pKey) => <React.Fragment key={pKey}>
                            <Grid sx={{ py: 2 }} >
                                <Divider />
                            </Grid>
                            <Grid>
                                <Box sx={{ fontSize: '14px', fontWeight: 500, pb: 1 }}>
                                    {p?.name} ({p?.terminal?.name})
                                </Box>
                                <Box sx={{ fontSize: '12px', fontWeight: 300 }}>
                                    {t("PopupPages.stars")} {p?.rating}
                                </Box>
                                <Box sx={{ fontSize: '12px', fontWeight: 300 }}>
                                    {details
                                        ? <>
                                            <Box>
                                                {parse(p?.description)}
                                            </Box>
                                            {p?.image && p?.image?.length > 100 && <Box sx={{
                                                width: '50%',
                                                padding: '10px 0',

                                            }}>
                                                <img src={`data:${p.imageContentType};base64,${p.image}`} alt="lounge" style={{ width: '100%', height: 'auto', borderRadius: '10px' }} />
                                            </Box>}
                                            <Box>
                                                {p?.openHours?parse(p?.openHours):''}
                                            </Box>
                                            <Box>
                                                {p?.details?parse(p?.details):''}
                                            </Box>
                                        </>
                                        : <><strong style={{ cursor: 'pointer' }} onClick={() => setDetails(true)}>{t("PopupPages.clickHere")}</strong> {t("PopupPages.serviceDetails")}</>}

                                </Box>
                            </Grid>

                            <Grid>
                                <Box>
                                    <Grid sx={{ textAlign: 'center', py: 2 }} spacing={2} container>
                                        <Grid item>
                                            <Box sx={{ fontWeight: 300, fontSize: '10px', p: 1 }}>
                                                for {formValues?.numberOfAdults} adults{formValues?.numberOfChildren?`, ${formValues?.numberOfChildren} children`:''}{formValues?.numberOfInfants?`, ${formValues?.numberOfInfants} infant`:''}
                                            </Box>
                                            <Box className="popupButton" sx={{ fontWeight: 700, fontSize: '16px', borderRadius: '20px', border: '1px solid #333', p: 1 }}>
                                                {p?.priceInCurrency} {p?.currency}
                                            </Box>
                                        </Grid>
                                        <Grid item>
                                             <Button
                                                 className="popupButton"
                                                 onClick={() => handleAddToCart(p)}
                                                 sx={{ fontWeight: 700, cursor: 'pointer', lineHeight: 1.25, color: '#d93e45', fontSize: '16px', borderRadius: '20px', border: isInCart(cart, p).isInCart ? '1px solid green' : '1px solid #d93e45', py: 1, px: 3, mt: 3.5 }}>
                                                 {isInCart(cart, p).isInCart ? t("PopupPages.remove") : t("PopupPages.cart")}
                                             </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </React.Fragment>)}
                    </Paper>
                </Container>

            </Box>

        </>
    );
}

export default LoungePopup;
